// extracted by mini-css-extract-plugin
export default {"wrapper":"LanguageSwitcher_wrapper__Yj-eE","btn":"LanguageSwitcher_btn__B21Ww","active":"LanguageSwitcher_active__XXv+Z","divider":"LanguageSwitcher_divider__7jDA-"};